import { axiosClient } from '../../../shared/api';

export const listVehicles = async (query = '') => {
  const response = await axiosClient.get(`/vehicles${query}`);
  return response.data;
};

export const getVehicleDetails = async (vehicleId) => {
  const response = await axiosClient.get(`/vehicles/${vehicleId}`);
  return response.data;
};

export const createVehicle = async (vehicleData) => {
  const response = await axiosClient.post('/vehicles', vehicleData);
  return response.data;
};

export const updateVehicle = async (vehicleId, updatedData) => {
  const response = await axiosClient.put(`/vehicles/${vehicleId}`, updatedData);
  return response.data;
};
